import React, { useEffect, useState } from "react";
import strings from "translate/language";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import {
  getMonthlyPropertyReport,
  getReportPropertyList,
} from "../../reduxStore/action/reportActions";
import { handleListResponse } from "utils/utils";
import Select from "react-select";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import "./PdrReport.css";
import "./KpiTracker.css";

const ReportManage = ({ isAuth = false }) => {
  const dispatch = useDispatch();
  const [viewData, setViewData] = useState({});
  const [formVaild, setFormVaild] = useState({});
  const [propertyList, setPropertyList] = useState([]);
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [expandedUsers, setExpandedUsers] = useState(null);
  const [expandedProperties, setExpandedProperties] = useState(() => new Set());

  const toggleUserExpand = (index, type) => {
    setExpandedUsers((prev) =>
      prev && prev.index === index && prev.type === type
        ? null
        : { index, type }
    );
  };

  const togglePropertyExpand = (index) => {
    setExpandedProperties((prev) => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  };

  const monthlyPropertyReportSelector =
    useSelector((state) => state.report) || {};
  const ReportListSelector = useSelector((state) => state.report);

  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    property_id: "",
  });

  useEffect(() => {
    const { reportPropertyList } = ReportListSelector;
    if (reportPropertyList) {
      if (reportPropertyList?.status === 200) {
        setPropertyList(handleListResponse(reportPropertyList.data));
      } else {
        setPropertyList([]);
      }
    }
  }, [ReportListSelector]);

  useEffect(() => {
    if (monthlyPropertyReportSelector.monthlyPropertyReport) {
      const { monthlyPropertyReport } = monthlyPropertyReportSelector;
      if (monthlyPropertyReport?.status === 200) {
        setViewData(handleListResponse(monthlyPropertyReport?.data));
      }
    }
  }, [monthlyPropertyReportSelector]);

  useEffect(() => {
    dispatch(getMonthlyPropertyReport());
  }, []);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: "",
      });
    }
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "") {
      if (form.end_date === "") {
        formError = true;
        err["end_date"] = strings.endDateErr;
      }
    }
    setFormVaild(err);
    return formError;
  };

  // Disable end_date
  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  const filterDetail = () => {
    if (!handleValid()) {
      dispatch(
        getMonthlyPropertyReport({
          start_date: form.start_date,
          end_date: form.end_date,
          property_id: form?.site?._id,
        })
      );
    }
  };

  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      property_id: "",
      site: "",
    });
    setFormVaild({
      ...formVaild,
      end_date: "",
    });
    dispatch(getMonthlyPropertyReport());
  };

  useEffect(() => {
    seo({
      title: "KPI Tracker Report",
      metaDescription: "Report management",
      canonicalLink: window.location.href,
    });
  }, []);

  const handleTotalCount = (prop) => {
    if (viewData?.length > 0) {
      return viewData?.reduce(function (a, b) {
        return a + b[prop];
      }, 0);
    }
  };

  //Download List data in excel file
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const date = new Date();
  const todayDate = form.start_date
    ? moment(form.start_date).format("DD-MM-YYYY")
    : moment(new Date(date.getFullYear(), date.getMonth(), 1)).format(
      "DD-MM-YYYY"
    );
  const lastDate = form.end_date
    ? moment(form.end_date).format("DD-MM-YYYY")
    : moment(new Date()).format("DD-MM-YYYY");
  const fileName = "REPORT" + todayDate + "_to_" + lastDate;
  const exportticketdata = async (apiData) => {
    try {
      if (viewData?.length > 0) {
        var customHeadings = viewData?.map((item) => ({
          "Property Title": item.property_title,
          Status: item.status ? "Active" : "Deactive",
          "Visitors Entry": item.leadCount,
          "Site Visit Create": item.sitevisitCount,
          "Checkins":item.checkinCount,
          "Actual Visit ": item.sitevisitcheckinCount,
          "No Show Visit": item.sitevisitnoshowCount,
          Revisit: item.revisitCount,
          "Customer Lost": item.sitevisitlostCount,
          "Booking Done": item.bookingCount,
          "Booking Cancel": item.cancelbookingCount,
          "New CP Registered": item.CpCount,
          "Total Maped CP": item.totalcpregister,
          "Total Employees": item.userCount,
          "Active Employees": item.AtiveuserCount,
          "Deactive Employees": item.InAtiveuserCount,
        }));
      } else {
      }
    } catch (e) { }

    const ws = XLSX.utils.json_to_sheet(customHeadings);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const metric = (value) => (value || value === 0 ? value : 0);
  const cleanLabel = (label = "") => String(label).replace(/\s*:\s*$/, "");

  const METRIC_GROUPS = [
    {
      id: "visits",
      title: "Visits",
      items: [
        { key: "leadCount", label: "Visitors" },
        { key: "sitevisitCount", label: "Site visits" },
        { key: "checkinCount", label: "Check-ins" },
        { key: "sitevisitcheckinCount", label: "Actual visits" },
        { key: "sitevisitnoshowCount", label: "No show" },
        { key: "revisitCount", label: "Revisits" },
        { key: "sitevisitlostCount", label: "Lost" },
      ],
    },
    {
      id: "bookings",
      title: "Bookings & CP",
      items: [
        { key: "bookingCount", label: "Bookings" },
        { key: "cancelbookingCount", label: "Cancelled" },
        { key: "CpCount", label: "New CP" },
        { key: "totalcpregister", label: "Mapped CP" },
      ],
    },
    {
      id: "team",
      title: "Team",
      items: [
        { key: "userCount", label: "Employees", expand: "total" },
        { key: "AtiveuserCount", label: "Active", expand: "active" },
        { key: "InAtiveuserCount", label: "Inactive", expand: "deactive" },
      ],
    },
  ];

  const employeePanelTitle = (type) => {
    if (type === "total") return strings.listTotalUser;
    if (type === "active") return strings.listActiveUser;
    return strings.listDectiveUser;
  };

  const employeeRowsFor = (item, type) => {
    if (type === "total") return item?.userInfo || [];
    if (type === "active") return item?.AtiveuserInfo || [];
    return item?.InAtiveuserInfo || [];
  };

  const selectMenuPortalProps = {
    menuPortalTarget:
      typeof document !== "undefined" ? document.body : null,
    menuPosition: "fixed",
    styles: {
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    },
  };

  const renderMetricValue = (index, item, count, expandable) => {
    if (!expandable || !count) {
      return <span className="justo-kpi__metric-value">{metric(count)}</span>;
    }
    const open =
      expandedUsers?.index === index && expandedUsers?.type === expandable;
    return (
      <button
        type="button"
        className="justo-kpi__expand-btn"
        onClick={() => toggleUserExpand(index, expandable)}
        aria-expanded={open}
        title={employeePanelTitle(expandable)}
      >
        <span className="justo-kpi__metric-value">{metric(count)}</span>
        <i
          className={`fa fa-caret-${open ? "up" : "down"}`}
          aria-hidden="true"
        />
      </button>
    );
  };

  const renderMetricGroups = (getCount, index = null) =>
    METRIC_GROUPS.map((group) => (
      <div className="justo-kpi__group" key={group.id}>
        <h3 className="justo-kpi__group-title">{group.title}</h3>
        <div className="justo-kpi__group-grid">
          {group.items.map((m) => (
            <div className="justo-kpi__metric" key={m.key}>
              <span className="justo-kpi__metric-label">
                {cleanLabel(m.label)}
              </span>
              {renderMetricValue(
                index,
                m,
                getCount(m.key),
                index !== null ? m.expand : undefined
              )}
            </div>
          ))}
        </div>
      </div>
    ));

  return (
    <div className="page-body justo-report-page justo-kpi-page">
      {isAuth && (
        <Breadcrumb
          title="KPI Tracker"
          parentListing={null}
          titleactive="Report"
        />
      )}
      <div className="justo-report justo-kpi">
        <div className="justo-report__card justo-kpi__card">
          <div className="justo-kpi__toolbar">
            <div className="justo-kpi__toolbar-copy">
              <h1 className="justo-kpi__heading">Property KPIs</h1>
              <p className="justo-kpi__hint">
                Filter by date or property, then review totals and per-project
                metrics.
              </p>
            </div>
            {viewData?.length > 0 ? (
              <button
                type="button"
                className="justo-report__btn justo-report__btn--outline"
                onClick={() => exportticketdata({}, "Report")}
              >
                {strings.exportList}
              </button>
            ) : null}
          </div>

          <form
            className="justo-report__filters justo-kpi__filters"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="justo-report__filters-grid justo-kpi__filters-grid">
              <label className="justo-report__field">
                <span className="justo-report__label">{strings.startDate}</span>
                <input
                  className="form-control justo-report__input"
                  type="date"
                  name="start_date"
                  value={form.start_date}
                  onChange={handleInputField}
                />
              </label>
              <label className="justo-report__field">
                <span className="justo-report__label">{strings.endDate}</span>
                <input
                  className="form-control justo-report__input"
                  type="date"
                  name="end_date"
                  value={form.end_date}
                  onChange={handleInputField}
                  min={form.start_date}
                  disabled={endDateDisable}
                />
                {formVaild.end_date ? (
                  <span className="justo-report__error">{formVaild.end_date}</span>
                ) : null}
              </label>
              <label className="justo-report__field">
                <span className="justo-report__label">
                  {strings.searchByPropertyName}
                </span>
                <Select
                  classNamePrefix="justo-kpi-select"
                  isSearchable
                  isClearable
                  {...selectMenuPortalProps}
                  onInputChange={(e) => {
                    if (e.length > 1) {
                      dispatch(
                        getReportPropertyList({
                          search_site: e,
                          isLoadMore: true,
                        })
                      );
                    } else {
                      dispatch(
                        getReportPropertyList({
                          limit: 10,
                          offset: 0,
                          isLoadMore: true,
                        })
                      );
                    }
                  }}
                  placeholder={strings.searchByPropertyName}
                  options={propertyList}
                  getOptionLabel={(option) => `${option.property_title}`}
                  getOptionValue={(option) => option._id}
                  name="site"
                  value={form.site}
                  onChange={(e) => {
                    setForm({ ...form, site: e });
                  }}
                />
              </label>
            </div>
            <div className="justo-report__filter-footer">
              <div className="justo-report__filter-actions">
                <button
                  type="button"
                  className="justo-report__btn justo-report__btn--solid"
                  onClick={filterDetail}
                >
                  {strings.search}
                </button>
                <button
                  type="button"
                  className="justo-report__btn justo-report__btn--ghost"
                  onClick={filterReset}
                >
                  {strings.reset}
                </button>
              </div>
            </div>
          </form>

          <div className="justo-kpi__body">
            <section className="justo-kpi__panel">
              <div className="justo-kpi__panel-head">
                <h2 className="justo-kpi__panel-title">
                  {strings.totalCountForall}
                </h2>
              </div>
              <div className="justo-kpi__groups">
                {renderMetricGroups((key) => handleTotalCount(key))}
              </div>
            </section>

            <section className="justo-kpi__panel">
              <div className="justo-kpi__panel-head">
                <h2 className="justo-kpi__panel-title">By property</h2>
                <span className="justo-kpi__panel-meta">
                  {viewData?.length > 0
                    ? `${viewData.length} project${
                        viewData.length === 1 ? "" : "s"
                      }`
                    : strings.notavailable}
                </span>
              </div>

              {viewData?.length > 0 ? (
                <div className="justo-kpi__property-list">
                  {viewData.map((item, index) => {
                    const isPropertyOpen = expandedProperties.has(index);
                    const open =
                      expandedUsers?.index === index
                        ? expandedUsers.type
                        : null;
                    const rows = open ? employeeRowsFor(item, open) : [];
                    return (
                      <article
                        className={`justo-kpi__property-card${
                          isPropertyOpen ? " is-open" : ""
                        }`}
                        key={item._id || index}
                      >
                        <button
                          type="button"
                          className="justo-kpi__property-head"
                          onClick={() => togglePropertyExpand(index)}
                          aria-expanded={isPropertyOpen}
                        >
                          <div className="justo-kpi__property-title-wrap">
                            <h3 className="justo-kpi__property-name">
                              {item.property_title}
                            </h3>
                            <span
                              className={`justo-kpi__badge ${
                                item.status
                                  ? "justo-kpi__badge--active"
                                  : "justo-kpi__badge--deactive"
                              }`}
                            >
                              {item.status ? "Active" : "Deactive"}
                            </span>
                          </div>
                          <div className="justo-kpi__property-summary">
                            <span>
                              Visitors{" "}
                              <strong>{metric(item.leadCount)}</strong>
                            </span>
                            <span>
                              Bookings{" "}
                              <strong>{metric(item.bookingCount)}</strong>
                            </span>
                            <span>
                              Team <strong>{metric(item.userCount)}</strong>
                            </span>
                            <i
                              className={`fa fa-chevron-${
                                isPropertyOpen ? "up" : "down"
                              }`}
                              aria-hidden="true"
                            />
                          </div>
                        </button>

                        {isPropertyOpen ? (
                          <>
                            <div className="justo-kpi__groups">
                              {renderMetricGroups(
                                (key) => item[key],
                                index
                              )}
                            </div>

                            {open ? (
                              <div className="justo-kpi__employee-panel">
                                <div className="justo-kpi__employee-head">
                                  {employeePanelTitle(open)}
                                </div>
                                <div className="justo-kpi__employee-scroll">
                                  <table className="justo-kpi__employee-table">
                                    <thead>
                                      <tr>
                                        <th scope="col">{strings.name}</th>
                                        <th scope="col">{strings.email}</th>
                                        <th scope="col">{strings.mobileNo}</th>
                                        <th scope="col">{strings.lastLogin}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {rows.length ? (
                                        rows.map((itm, idx) => (
                                          <tr key={idx}>
                                            <td>
                                              {itm.user_name
                                                ? itm.user_name
                                                : "-"}
                                            </td>
                                            <td>
                                              {itm.email ? itm.email : "-"}
                                            </td>
                                            <td>
                                              {itm.mobile ? itm.mobile : "-"}
                                            </td>
                                            <td>
                                              {itm.last_login
                                                ? moment
                                                    .utc(itm.last_login)
                                                    .format(
                                                      "DD-MM-yyyy hh:mm a"
                                                    )
                                                : "-"}
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan={4}>
                                            {strings.notavailable}
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            ) : null}
                          </>
                        ) : null}
                      </article>
                    );
                  })}
                </div>
              ) : (
                <p className="justo-kpi__empty">{strings.notavailable}</p>
              )}
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ReportManage;
